// AUTOGENERATED by projects/lib/scripts/build-design-tokens.mjs
// Source of truth: projects/lib/DESIGN.md
// Do not edit by hand. Run `npm run tokens:build` to regenerate.

export const tokens = {
  "colors": {
    "primary": "#164B41",
    "primary-hover": "#0F342D",
    "primary-soft": "#E2F1EE",
    "on-primary": "#FFFFFF",
    "brand-sage": "#545A34",
    "surface": "#FFFFFF",
    "surface-muted": "#F9FAFB",
    "surface-sunken": "#F3F4F6",
    "border": "#E5E7EB",
    "border-strong": "#D1D5DB",
    "text": "#111827",
    "text-muted": "#6B7280",
    "text-subtle": "#9CA3AF",
    "success": "#16A34A",
    "warning": "#F59E0B",
    "danger": "#DC2626",
    "info": "#2563EB",
    "rubro-carne": "#FCA5A5",
    "rubro-pastas": "#FCD34D",
    "rubro-arroces": "#FDBA74",
    "rubro-cazuelas": "#F87171",
    "rubro-masas": "#FBBF24",
    "rubro-sandwich": "#C4B5FD",
    "rubro-ensaladas": "#86EFAC",
    "rubro-sopas": "#67E8F9",
    "rubro-postres": "#F9A8D4"
  },
  "typography": {
    "display-lg": {
      "fontFamily": "Poppins",
      "fontSize": "34px",
      "fontWeight": 700,
      "lineHeight": 1.15,
      "letterSpacing": "-0.02em"
    },
    "display-md": {
      "fontFamily": "Poppins",
      "fontSize": "26px",
      "fontWeight": 700,
      "lineHeight": 1.2,
      "letterSpacing": "-0.015em"
    },
    "title": {
      "fontFamily": "Poppins",
      "fontSize": "18px",
      "fontWeight": 600,
      "lineHeight": 1.3
    },
    "body-md": {
      "fontFamily": "Poppins",
      "fontSize": "14px",
      "fontWeight": 400,
      "lineHeight": 1.5
    },
    "body-sm": {
      "fontFamily": "Poppins",
      "fontSize": "13px",
      "fontWeight": 400,
      "lineHeight": 1.45
    },
    "label": {
      "fontFamily": "Poppins",
      "fontSize": "12px",
      "fontWeight": 500,
      "lineHeight": 1.3,
      "letterSpacing": "0.02em"
    },
    "eyebrow": {
      "fontFamily": "Poppins",
      "fontSize": "11px",
      "fontWeight": 600,
      "lineHeight": 1.2,
      "letterSpacing": "0.08em"
    },
    "numeric": {
      "fontFamily": "Poppins",
      "fontSize": "14px",
      "fontWeight": 500,
      "lineHeight": 1.4,
      "fontFeature": "'tnum'"
    }
  },
  "spacing": {
    "xs": "4px",
    "sm": "8px",
    "md": "12px",
    "lg": "16px",
    "xl": "24px",
    "xxl": "32px"
  },
  "rounded": {
    "sm": "4px",
    "md": "8px",
    "lg": "12px",
    "full": "9999px"
  },
  "components": {
    "button-primary": {
      "backgroundColor": "#164B41",
      "textColor": "#FFFFFF",
      "rounded": "8px",
      "typography": "[object Object]",
      "padding": "10px 18px"
    },
    "button-secondary": {
      "backgroundColor": "#FFFFFF",
      "textColor": "#111827",
      "rounded": "8px",
      "padding": "10px 18px"
    },
    "card": {
      "backgroundColor": "#FFFFFF",
      "rounded": "12px",
      "padding": "16px"
    },
    "kpi-card": {
      "backgroundColor": "#FFFFFF",
      "rounded": "12px",
      "padding": "12px"
    },
    "input": {
      "backgroundColor": "#FFFFFF",
      "textColor": "#111827",
      "rounded": "8px",
      "padding": "8px 12px"
    }
  }
} as const;

export type DesignTokens = typeof tokens;
export type ColorToken = keyof typeof tokens.colors;
export type TypographyToken = keyof typeof tokens.typography;
export type SpacingToken = keyof typeof tokens.spacing;
export type RoundedToken = keyof typeof tokens.rounded;
